import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const Mouse = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='Mouse' {...props}>
    <path fillRule='evenodd' clipRule='evenodd' d='M6 9C6 5.68629 8.68629 3 12 3C15.3137 3 18 5.68629 18 9V11V15C18 18.3137 15.3137 21 12 21C8.68629 21 6 18.3137 6 15V11V9ZM8 11V15C8 17.2091 9.79086 19 12 19C14.2091 19 16 17.2091 16 15V11H8ZM16 9C16 7.13616 14.7252 5.57006 13 5.12602V9H16ZM11 9H8C8 7.13616 9.27477 5.57006 11 5.12602V9Z' fill='#000' />
  </StyledIcon>
);
